import { RedirectCategoryTypes } from '../enums';
import { ProductListModel } from './Product';

export interface Category {
  id: number;
  parentId: number;
  redirectCategoryId?: number;
  redirectType: RedirectCategoryTypes;
  name: string;
  image: string;
  image2: string;
  discount: number;
  taxClassIds: number[];
  employerTaxClassIds: number[];
  taxes?: number[];
  showSubmenu: boolean;
  isSaveEveryday: boolean;
  children: Category[];
}

export interface CategoryDetails {
  categoryId: number;
  redirectCategoryId?: number;
  redirectType: RedirectCategoryTypes;
  description: string;
  showBenefitBucksWallet: boolean;
  isVoucherDiscountCategory: boolean;
  shouldFallback: boolean;
}

export interface Dictionary<V> {
  [id: string | number]: V;
}

export interface TopCategoryModel {
  categoryId: number;
  name: string;
  topProducts: ProductListModel[];
}

export interface ExclusiveCategoryModel {
  categoryId: number;
  categoryName: string;
  description: string;
  parentId: number;
  image: string;
  image2: string;
}

export interface HomeCategories {
  smartSpendings: SmartSpendingItem[];
  saveEveryday: SaveEveryDayCategoryItem[];
  topDeals: ProductListModel[];
}

export interface SmartSpendingItem {
  name: string;
  imagePath: string;
  type: RedirectTypes;
  goTo?: number;
  brand?: number;
  minTaxRate?: number;
  maxTaxRate?: number;
}

export enum RedirectTypes {
  NoRedirect = 0,
  Browse = 1,
  Product = 2,
  FlexibleBenefits = 3,
  ClubBenefits = 4,
  EdenredCards = 5,
  ProductType = 6,
  MyBudget = 7,
  Cashback = 8,
  DiscountVouchers = 9,
  ActiveBenefits = 10,
}

export interface SaveEveryDayCategoryItem {
  categoryId: number;
  name: string;
  imagePath: string;
  description: string;
  source: HomeCategorySource;
}

export enum HomeCategorySource {
  FlexibleBenefits = 1,
  BenefitClub = 2,
}

export enum ShortcutTypes {
  VacationCard = 1,
  MealCard = 2,
  GiftCard = 3,
  CulturalCard = 4,
  MyBudget = 5,
  CategoryCard = 6,
  Cashback = 8,
  ActiveBenefits = 9,
}

export interface HomeShortcutAction {
  type: RedirectTypes;
  goTo?: number | null;
  goToName?: string | null;
  label: string;
}

export interface HomeShortcut {
  shortcutType: ShortcutTypes;
  title: string;
  subtitle: string;
  description: string;
  mainImage: string;
  secondaryImage: string;
  primaryAction: HomeShortcutAction | null;
  secondaryAction: HomeShortcutAction | null;
}
